{
  "appointment-card": {
    "buttons": {
      "details": "Détails"
    },
    "text": {
      "and-more": "et {{nr}} plus",
      "cancelled": "ANNULÉ",
      "minutes": "minutes"
    }
  }
}
